import { render, staticRenderFns } from "./PopupOrderSuccess.vue?vue&type=template&id=c2336330&scoped=true&"
import script from "./PopupOrderSuccess.vue?vue&type=script&lang=js&"
export * from "./PopupOrderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PopupOrderSuccess.vue?vue&type=style&index=0&id=c2336330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2336330",
  null
  
)

export default component.exports